import {
  Box,
  Chip,
  Grid,
  Paper,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material'
import moment from 'moment'
import React from 'react'
import VpnKeyIcon from '@mui/icons-material/VpnKey'

const getStatus = (drug) => {
  if (drug.expiry && moment().isAfter(moment(drug.expiry))) {
    return { label: 'Out of date', color: '#DC2626' }
  }

  if (drug.expiry && moment(drug.expiry).isBefore(moment().add(30, 'days'))) {
    return { label: 'Expiring', color: '#D97706' }
  }

  if (Number(drug.qty || 0) < Number(drug.alarm || 0) || drug.qty === 0) {
    return { label: 'Low stock', color: '#0891B2' }
  }

  return { label: 'Good', color: '#16A34A' }
}

const DrugBox = ({ drug, onClick }) => {
  const status = getStatus(drug)

  return (
    <Grid item xs={12} md={6} lg={4}>
      <Paper
        elevation={0}
        onClick={onClick}
        sx={{
          p: 1.25,
          borderRadius: 2,
          border: '1px solid rgba(15,23,42,0.08)',
          borderLeft: `5px solid ${status.color}`,
          backgroundColor: '#fff',
          cursor: onClick ? 'pointer' : 'default',
          transition: 'border-color 0.18s ease, transform 0.18s ease',
          '&:hover': onClick
            ? {
                borderColor: `${status.color}88`,
                transform: 'translateY(-1px)',
              }
            : undefined,
        }}
      >
        <Stack spacing={1} height="100%" justifyContent="space-between">
          <Stack direction="row" spacing={1} justifyContent="space-between">
            <Stack minWidth={0} spacing={0.25}>
              <Stack direction="row" spacing={0.75} alignItems="center">
                <Typography fontWeight={900} lineHeight={1.15} noWrap>
                  {drug.name}
                </Typography>
                {drug.isControlled && (
                  <Tooltip title="Controlled drug">
                    <VpnKeyIcon sx={{ color: '#DC2626', fontSize: 18 }} />
                  </Tooltip>
                )}
              </Stack>

              <Typography variant="caption" color="text.secondary" noWrap>
                {[drug.presentation, drug.constitution]
                  .filter(Boolean)
                  .join(' · ')}
              </Typography>
            </Stack>

            <Box
              sx={{
                minWidth: 42,
                height: 36,
                px: 1,
                borderRadius: 1.5,
                display: 'grid',
                placeItems: 'center',
                color: status.color,
                backgroundColor: `${status.color}12`,
                fontWeight: 950,
                flexShrink: 0,
              }}
            >
              {drug.qty}
            </Box>
          </Stack>

          <Stack direction="row" spacing={0.75} flexWrap="wrap" useFlexGap>
            <Chip
              size="small"
              label={status.label}
              sx={{
                height: 22,
                borderRadius: 1,
                color: status.color,
                fontWeight: 850,
                backgroundColor: `${status.color}12`,
              }}
            />
            {drug.expiry && (
              <Chip
                size="small"
                label={`Exp ${moment(drug.expiry).format('DD MMM YYYY')}`}
                sx={{ height: 22, borderRadius: 1, fontWeight: 800 }}
              />
            )}
          </Stack>
        </Stack>
      </Paper>
    </Grid>
  )
}

export default DrugBox
